import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Buttons',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
